import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadAuftragRechnungListStatus: 'idle',
    loadAuftragRechnungListError: undefined as any,
    loadAuftragRechnungListLastArgs: undefined as any,

    auftragRechnungList: [] as any[],
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadAuftragRechnungList = createAsyncThunk('auftragRechnungSlice/loadAuftragRechnungList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().auftragRechnungSlice.loadAuftragRechnungListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/reestmaftrrel/?action=gte&MIN_AUFTRAGID=${parentModel.HDR_ID}&MAX_AUFTRAGID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragRechnungListStatus } = getState().auftragRechnungSlice
        return loadAuftragRechnungListStatus !== 'pending'
    }
})

const AuftragRechnungSlice = createSlice({
    name: 'auftragRechnungSlice',
    initialState,
    reducers: {
        resetloadAuftragRechnungListError: (state) => {
            state.loadAuftragRechnungListError = undefined
        },
        removeFromAuftragRechnungListById: (state, action) => {
            state.auftragRechnungList = state.auftragRechnungList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromAuftragRechnungListByIds: (state, action) => {
            state.auftragRechnungList = state.auftragRechnungList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.auftragRechnungList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadAuftragRechnungListStatus = 'preloaded'
            state.loadAuftragRechnungListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.auftragRechnungList = []
            state.loadAuftragRechnungListStatus = 'idle'
            state.loadAuftragRechnungListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadAuftragRechnungList.pending, (state) => {
            state.loadAuftragRechnungListStatus = 'pending'
            state.loadAuftragRechnungListError = undefined
        })
        builder.addCase(loadAuftragRechnungList.fulfilled, (state, action) => {
            state.loadAuftragRechnungListStatus = 'idle'

            if (!action.payload) { return }

            state.loadAuftragRechnungListLastArgs = action.payload.args

            {
                state.auftragRechnungList = action.payload.data

            }
        })
        builder.addCase(loadAuftragRechnungList.rejected, (state, action) => {
            state.loadAuftragRechnungListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragRechnungListError = action.error.message
            } else {
                state.loadAuftragRechnungListError = action.payload
            }
        })

    }
})

export const {
    resetloadAuftragRechnungListError,
    removeFromAuftragRechnungListById,
    removeFromAuftragRechnungListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = AuftragRechnungSlice.actions
export default AuftragRechnungSlice.reducer
